module.exports = __webpack_public_path__ + "assets/img/6icon.946fdeca.png";